import { useEffect } from "react";

/**
 * Landing page (`/`).
 *
 * The visible HTML content for `/` is the **pre-rendered Next.js homepage**
 * inlined into `public/index.html` inside `<div id="seo-shell">` at build
 * time (see `scripts/build-homepage-shell.mjs`). That gives us:
 *   • Real SSG/SSR-equivalent SEO content for Google, GPTBot, ChatGPT, etc.
 *   • A homepage that looks identical to /jak-to-funguje, /prani-pradla-praha
 *     and all the other Next.js pages.
 *
 * This React component therefore renders nothing — it only toggles the
 * visibility of `#seo-shell` so SPA navigation between `/` and `/admin`,
 * `/dashboard`, etc. shows the right thing without a page reload.
 */
const Landing = () => {
  useEffect(() => {
    const shell = document.getElementById("seo-shell");
    if (shell) shell.style.display = "block";
    return () => {
      // Hide on unmount so that other SPA routes don't show the SEO shell behind them.
      if (shell) shell.style.display = "none";
    };
  }, []);

  return null;
};

export default Landing;
